<div class="card" (click)="goto($event, defaultLink)">
    <div class="clear" *ngIf="auth.canDelete(this.auth.user$ | async) && showDelete" (click)="deleteHandler($event)">
        <mat-icon>clear</mat-icon>
    </div>
    <div class="clear" *ngIf="auth.canEdit(this.auth.user$ | async) && showEdit" (click)="updateHandler($event)">
        <mat-icon>edit</mat-icon>
    </div>
    <div class="action" *ngFor="let actionButton of actionButtons;  let i = index">
        <mat-icon [ngClass]="actionButton['hoverColor']" [matTooltip]="actionButton['tooltip']"
            (click)="actionTriggeredHandler($event, i, defaultLink, actionButton['relativeUrl'])">{{actionButton['icon']}}
        </mat-icon>
    </div>
    <div>
        <h5 [matTooltip]="title"> {{title}}</h5>
    </div>
</div>